@let flag = combined$ | async;
<div class="modal-body p-6">
  @if (!isLoading) {
    <div class="d-flex d-md-block w-100 justify-content-between">
      <div id="close" class="dismiss order-2 order-md-1 d-flex mt-2 mt-md-0 mb-md-4 ml-2 justify-content-end" 
      (click)=" onKeepPlanOrClose()" 
      (keyup.enter)="bsModalRef.hide()" 
      aria-label="Close"
      trackLink = "{{disableClickTracking ?? 'back'}}"
      trackType = "{{disableClickTracking ? '':'o'}}"
      [prop15]="'back'"
      [prop10]="trackingString('button',['click','back'])"
      [evar33]="trackingString('button',['click','back'])">
        <a class="text-decoration-none gb-icon-button" href="javascript:void">
          <span aria-hidden="true" class="icon-ui-close"></span>
        </a>
      </div>
      <div class="gb-headline1 mb-3 order-1 order-md-2">{{getGenericCopy$('checkout.downgrade.header', {'PLAN': downgrade?.planName ?? 'your new plan'}) | async | uppercase}}</div>
    </div>
    <div class="mb-3">{{getGenericCopy$('checkout.lost.services', {'PLAN': downgrade?.planName ?? 'Your plan', 'DATE': downgrade?.planStartDate ?? 'a future date'}) | async}}</div>
    @for (feature of lostFeatures; track feature) {
      @if(flag?.[1]){
        <li>{{feature}}</li>
      }
      @if(isFeatureObj(feature)){
        <li>{{feature.name}}</li>
      }
    }
    <div class="d-flex justify-content-end">
      <div class="row p-0 mx-0 mt-5 edit-payment-btn-container">
        <div class="col-12 col-md-6 order-12 order-md-1 p-0 pr-md-3">
          <button class="gb-secondary-button col mr-md-3" 
            (click)="onKeepPlanOrClose()"
            tabindex="0"
            trackLink = "{{disableClickTracking ?? (getGenericCopy$('checkout.keep.plan') | async)}}"
            trackType = "{{disableClickTracking ? '': 'o'}}"
            [prop15]="(getGenericCopy$('checkout.keep.plan') | async)??'keep plan'"
            [prop10]="trackingString('button',['click',(getGenericCopy$('checkout.keep.plan') | async)??'keep plan'])"
            [evar33]="trackingString('button',['button','click',(getGenericCopy$('checkout.keep.plan') | async)??'keep plan'])">
            {{(getGenericCopy$('checkout.keep.plan') | async | titlecase)}}
          </button>
        </div>
        <div class="col-12 col-md-6 order-2 p-0 mb-3">
          <button class="gb-primary-button col"
            tabindex="0"
            trackLink = "{{ disableClickTracking ?? (getGenericCopy$('checkout.downgrade.continue', {'PLAN': downgrade?.planName || 'YOUR NEW PLAN'}) | async)}}"
            trackType = "{{disableClickTracking ? '': 'o'}}"
            [prop15]="(getGenericCopy$('checkout.downgrade.continue', {'PLAN': downgrade?.planName ?? 'YOUR NEW PLAN'}) | async)?? 'YOUR NEW PLAN'"
            [prop10]="trackingString('button',['click',(getGenericCopy$('checkout.downgrade.continue', {'PLAN': downgrade?.planName ?? 'YOUR NEW PLAN'}) | async)?? 'YOUR NEW PLAN'])"
            [evar33]="trackingString('button',['click',(getGenericCopy$('checkout.downgrade.continue', {'PLAN': downgrade?.planName ?? 'YOUR NEW PLAN'}) | async)?? 'YOUR NEW PLAN'])" 
            (click)="onContinue()">
            {{getGenericCopy$('checkout.downgrade.continue', {'PLAN': downgrade?.planName ?? 'Your New Plan'}) | async | titlecase}}
          </button>
        </div>
      </div>
    </div>
  }
  @else {
    <ox-loading></ox-loading>
  }
</div>